import { apiAction } from './api';
import endpoints from './endpoints';
import dateUtil from '../util/dateUtil';
import { baseDraft, ENTRY_TYPE_DRAFT } from '../config/staticValues';
import { setMessage } from './message';
import { nullAction } from './general';
import { getTimecard, setTimecard } from './timecard';

//constants
export const SET_DRAFT = 'SET_DRAFT';
export const SAVE_DRAFT = 'SAVE_DRAFT';
export const PLAY_NOW = 'PLAY_NOW';
export const RESET_DRAFT = 'RESET_DRAFT';
export const CANCEL_PLAYING = 'CANCEL_PLAYING';
export const CLEAR_DRAFT_MESSAGE = 'CLEAR_DRAFT_MESSAGE';

const initialState = { ...baseDraft };

//actions
export const setDraft = (data) => {
  return {
    type: SET_DRAFT,
    payload: data,
  };
};

export const resetDraft = () => {
  return {
    type: RESET_DRAFT,
  };
};

export const clearDraftMessage = () => {
  return {
    type: CLEAR_DRAFT_MESSAGE,
  };
};

export const playNow = (item, timecardId, type) => {
  let draft = Object.assign({}, baseDraft);
  draft.timecardId = timecardId;
  draft.companyName = item.companyName;
  draft.companyShortName = item.companyShortName;
  draft.incidentId = item.incidentId;
  draft.incidentName = item.incidentName;
  draft.taskId = item.taskId;
  draft.taskNumber = item.taskNumber;
  draft.taskName = item.taskName;
  draft.startDate = item.startDate || dateUtil.nowDateString();
  draft.endDate = item.endDate || dateUtil.nowDateString();
  draft.startTime = item.startTime || dateUtil.nowTimeString();
  draft.endTime = item.endTime;
  draft.type = ENTRY_TYPE_DRAFT;
  draft.status = 'RUNNING';
  draft.noCharge = item.noCharge || '0';
  draft.payBonus = item.payBonus == '0' ? '0' : item.payBonus || '1';
  draft.description = item.description || '';
  return apiAction({
    //label: 'PLAY_NOW',  //removing this cause the screen to not overlay
    url: endpoints.createEntry,
    method: 'POST',
    data: draft,
    onSuccess: [
      (payload) => setTimecard(payload.timecard),
      (payload) => setDraft(payload.entry),
    ],
  });
};

export const autoSaveDraft = (draft) => {
  return apiAction({
    url: endpoints.putDraft,
    onSuccess: [(payload) => setTimecard(payload.timecard), clearDraftMessage],
    onFailure: (error) => {
      const reason = error?.response?.data?.validationMessage;
      return reason ? setDraft({ ...draft, validationMessage: reason }) : nullAction();
    },
    data: draft,
    method: 'PUT',
    label: SAVE_DRAFT,
    showLoading: false,
  });
};

export const stopPlaying = (entry) => {
  return apiAction({
    url: endpoints.putEntry,
    onSuccess: [(payload) => setTimecard(payload.timecard), resetDraft],
    onFailure: [
      () => getTimecard(entry.timecardId),
      resetDraft,
      //the draft row is written before validation runs, so a rejected entry really does
      //survive as a draft - but if the request never reached the server, nothing was saved
      (error) => {
        const reason = error?.response?.data?.validationMessage;
        return reason
          ? setMessage('Saved as draft: ' + reason, 'warning')
          : setMessage('Could not stop - please try again', 'error');
      },
    ],
    data: entry,
    method: 'PUT',
    label: SAVE_DRAFT,
    showLoading: false,
  });
};

export const checkForNowPlaying = (timecard) => {
  const runningDraft = timecard?.timecardId
    ? timecard.entries.find(
      (entry) => entry.type === 'DRAFT' && entry.status === 'RUNNING'
    )
    : null;
  return setDraft(runningDraft || initialState);
};

export const cancelPlaying = (entry) => {
  return apiAction({
    url: endpoints.deleteEntry,
    onSuccess: [(payload) => setTimecard(payload), resetDraft],
    onFailure: () => setMessage('Something went wrong', 'error'),
    method: 'DELETE',
    data: { id: entry.id, type: 'DRAFT' },
    label: CANCEL_PLAYING,
  });
};

//reducer
export const draft = (state = initialState, action) => {
  switch (action.type) {
    case SET_DRAFT:
      return action.payload;
    case CANCEL_PLAYING:
      return action.payload;
    case RESET_DRAFT:
      return initialState;
    case CLEAR_DRAFT_MESSAGE:
      return state.validationMessage
        ? { ...state, validationMessage: undefined }
        : state;
    default:
      return state;
  }
};
